module.exports = __webpack_public_path__ + "media/styles/images/png/circle-right-arrow-teal-on-white-941bdfbd2e43a590afc4660a7a2e9958.png";